import { render, staticRenderFns } from "./FluffyFooter.vue?vue&type=template&id=6d363154&scoped=true&"
import script from "./FluffyFooter.vue?vue&type=script&lang=js&"
export * from "./FluffyFooter.vue?vue&type=script&lang=js&"
import style0 from "./FluffyFooter.vue?vue&type=style&index=0&id=6d363154&lang=scss&scoped=true&"
import style1 from "./FluffyFooter.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d363154",
  null
  
)

export default component.exports